import React, { useState } from 'react';
import { BarChart3Icon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
type Notification = {
  id: string;
  event: string;
  date: string;
  impact: 'high_negative' | 'medium_negative' | 'low_positive' | 'medium_positive' | 'high_positive';
  acknowledgedBy: string | null;
};
const notifications: Notification[] = [{
  id: '1',
  event: 'DBT increased from 6 days to 10 days',
  date: '3/16/2026',
  impact: 'medium_negative',
  acknowledgedBy: null
}, {
  id: '2',
  event: 'Pulse Score increased from 74 to 82 (+8 points)',
  date: '2/20/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Dave Davidson'
}, {
  id: '3',
  event: 'Strong revenue growth reported in Q1 financials',
  date: '1/15/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Dave Davidson'
}];
function ImpactIndicator({
  impact
}: {
  impact: Notification['impact'];
}) {
  if (impact === 'high_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2807" data-mp="1kxnezn2m2xfz">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2808" data-mp="1ky5k79794m01" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2809" data-mp="1fzlz1b0hfe8q" />
        <div className="w-1.5 h-5 bg-red-500 rounded-sm" data-id="element-2810" data-mp="1g15amob71146" />
      </div>;
  }
  if (impact === 'medium_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2811" data-mp="1pwqllby8pbq2">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2812" data-mp="1pzcqt4xnrf54" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2813" data-mp="23vghwpd8j7dd" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2814" data-mp="1yxy4oms6q5zk" />
      </div>;
  }
  if (impact === 'low_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2815" data-mp="2dlj9qm8mefa4">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2816" data-mp="28nq4bvf55paw" />
        <div className="w-1.5 h-3.5 bg-gray-200 rounded-sm" data-id="element-2817" data-mp="28o9mnd8pefpg" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2818" data-mp="2mmhi1gq3d8yi" />
      </div>;
  }
  if (impact === 'medium_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2819" data-mp="2hpqy2ib61t7t">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2820" data-mp="1fbjdwrwfmtc6" />
        <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2821" data-mp="1f8x7wwp6wlw2" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2822" data-mp="1kamhe7wrkri1" />
      </div>;
  }
  // high_positive
  return <div className="flex items-end gap-0.5 justify-center" data-id="element-2823" data-mp="1o9vadajzclcj">
      <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2824" data-mp="1t2eqofa1xul1" />
      <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2825" data-mp="1t3zlm60a3fjf" />
      <div className="w-1.5 h-5 bg-green-500 rounded-sm" data-id="element-2826" data-mp="1y0g7etk09htc" />
    </div>;
}
export function NotificationsTab() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const toggleAll = () => {
    if (selected.size === notifications.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(notifications.map(n => n.id)));
    }
  };
  const toggleOne = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelected(next);
  };
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2827" data-mp="a373k4vfalof">
      <div className="p-5 border-b border-gray-200" data-id="element-2828" data-mp="5cqlg7gnqbvq">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-2829" data-mp="5b78oqu7miyp">Notifications</h3>
      </div>
      <div className="overflow-x-auto" data-id="element-2830" data-mp="ep2rnn58eks">
        <table className="w-full text-sm text-left" data-id="element-2831" data-mp="bb34n5v6jh1">
          <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2832" data-mp="3sihluq1vxqw6">
            <tr data-id="element-2833" data-mp="t2uoodpxo9m7">
              <th className="px-5 py-3 w-10" data-id="element-2834" data-mp="t19x8wyx16sk">
                <input type="checkbox" checked={selected.size === notifications.length} onChange={toggleAll} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2835" data-mp="szysattqhszv" />
              </th>
              <th className="px-5 py-3 font-medium" data-id="element-2836" data-mp="34rlz47cadlvs">Event</th>
              <th className="px-5 py-3 font-medium text-center w-32" data-id="element-2837" data-mp="34t6tnwylp4tn">Date</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-2838" data-mp="2zrzmo04a89o1">Impact</th>
              <th className="px-5 py-3 font-medium text-center w-40" data-id="element-2839" data-mp="rjugzqbyc0ik">
                Acknowledged By
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-2840" data-mp="wcvxg2rt4849">
            {notifications.map(n => <tr key={n.id} className="hover:bg-gray-50 transition-colors" data-id="element-2841" data-mp="ihbjllqxqg3p">
                <td className="px-5 py-4" data-id="element-2842" data-mp="mlj5zc9x7jyr">
                  <input type="checkbox" checked={selected.has(n.id)} onChange={() => toggleOne(n.id)} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2843" data-mp="1aau0ic0ogi4g" />
                </td>
                <td className="px-5 py-4 text-gray-900" data-id="element-2844" data-mp="1687hn0lzi7je">{n.event}</td>
                <td className="px-5 py-4 text-gray-500 text-center whitespace-nowrap" data-id="element-2845" data-mp="3m04qxgt4e8pf">
                  {n.date}
                </td>
                <td className="px-5 py-4 text-center" data-id="element-2846" data-mp="3qzhmqr1yyq45">
                  <ImpactIndicator impact={n.impact} data-id="element-2847" data-mp="3qwv8k8kkpccy" />
                </td>
                <td className="px-5 py-4 text-gray-500 text-center" data-id="element-2848" data-mp="3ige2ukgckn3q">
                  {n.acknowledgedBy ?? '--'}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-4 px-5 py-3 border-t border-gray-200 text-sm text-gray-500" data-id="element-2849" data-mp="3seamk0ncoqdg">
        <span data-id="element-2850" data-mp="2zrplg8h2ozwp">Rows per page: 5</span>
        <span data-id="element-2851" data-mp="2zsr8zcf9zevb">1–5 of 5</span>
        <div className="flex gap-1" data-id="element-2852" data-mp="2zrzc7y9xzb3g">
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2853" data-mp="2usmnt93f9vyr">
            ‹
          </button>
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2854" data-mp="39hslgsmm3e4j">
            ›
          </button>
        </div>
      </div>
    </div>;
}